export const LEAD_CONNECTION_IDS = Object.freeze([5, 31, 32]);

export const LEAD_SOURCE_BY_WHATSAPP_ID = Object.freeze({
  5: "funnel",
  31: "funnel-alt",
  32: "funnel-rafaelle"
});

export const LEAD_ROUTE_CONFIG = Object.freeze({
  xai: {
    navValue: "lead-xai",
    path: "/leads",
    label: "Xai",
    title: "Funil Xai",
    countLabel: "na Xai",
    source: "funnel",
    whatsappId: 5,
    accent: "#4a0072",
    accentLight: "rgba(74,0,114,0.06)",
    accentBorder: "rgba(74,0,114,0.2)",
    accentHover: "rgba(74,0,114,0.12)",
    gradientEnd: "#7b1fa2"
  },
  rafaelle: {
    navValue: "lead-rafaelle",
    path: "/leads-rafaelle",
    label: "Rafaelle",
    title: "Funil Rafaelle",
    countLabel: "na Rafaelle",
    source: "funnel-rafaelle",
    whatsappId: 32,
    accent: "#6a1b9a",
    accentLight: "rgba(106,27,154,0.06)",
    accentBorder: "rgba(106,27,154,0.2)",
    accentHover: "rgba(106,27,154,0.12)",
    gradientEnd: "#ab47bc"
  },
  marcella: {
    navValue: "lead-marcella",
    path: "/leads-marcella",
    label: "Marcella",
    title: "Funil Marcella",
    countLabel: "na Marcella",
    source: "funnel-alt",
    whatsappId: 31,
    accent: "#0d3968",
    accentLight: "rgba(13,57,104,0.06)",
    accentBorder: "rgba(13,57,104,0.2)",
    accentHover: "rgba(13,57,104,0.12)",
    gradientEnd: "#1565c0"
  }
});

export const isLeadConnectionId = (value) =>
  LEAD_CONNECTION_IDS.includes(Number(value));

export const getLeadSourceByWhatsappId = (value) =>
  LEAD_SOURCE_BY_WHATSAPP_ID[Number(value)] || "funnel";
